import {convertToRaw} from 'draft-js';
import type {ContentState} from 'draft-js';
import {convertFromDraftJsToHtml} from '../../../../shared/components/rich-text-editor-draftjs-wrapper/DraftJsToHtmlConverter';
import {ticketingEntityTransform} from '../../tickets/utils/ticketingEntityTransform';
import {sanitizeMessageHtml} from '../../tickets/utils/sanitizeMessageHtml';

export function autoReplyEditorToHtml(contentState: ContentState): string {
	const plainText = contentState.getPlainText().trim();
	if (!plainText) return '';

	const raw = JSON.stringify(convertToRaw(contentState));
	const rawHtml = convertFromDraftJsToHtml(raw, ticketingEntityTransform);

	return sanitizeMessageHtml(rawHtml);
}
